import { format } from "date-fns";
import { IOperationalNotificationsGuiModel } from "../model/IOperationalNotificationsGuiModel";
import { IOperationalNotificationsModel } from "../service/model/IOperationalNotificationsModel";
import { BusinessLogicDefaultResult, BusinessLogicResult, PageBusinessLogicResult } from "./BusinessLogicResult";
import OperationalNotificationsService from "../service/OperationalNotificationsService";

export default class OperationalNotificationsBusinessLogic {

    public async getOperationalNotifications(): Promise<BusinessLogicResult<IOperationalNotificationsGuiModel[]>> {
        const service = new OperationalNotificationsService();
        const result = await service.getAllStatusNotifications();

        const notifications = result.value.map((n) => ({
            id: n.id,
            messageText: n.messageText,
            source: n.source,
            sourceReference: n.sourceReference,
            sourceCreated: n.sourceCreated ? format(new Date(n.sourceCreated), 'yyyy-MM-dd') : 'No date',  // Format date
            createdBy: n.createdBy,
            sourceModified: n.sourceModified ? format(new Date(n.sourceModified), 'yyyy-MM-dd') : 'No date',  // Format date
            modifiedBy: n.modifiedBy,
            resolved: n.resolved ? format(new Date(n.resolved), 'yyyy-MM-dd') : 'Unresolved', // Format date
        }));

        return new BusinessLogicResult(notifications, result.errors);
    }
}